const getState = state => state.SharedPresentationStore

const getFetchRequest = state => getState(state).fetchRequest
const getCopyRequest = state => getState(state).copyRequest
const getSharedPresentation = state => getState(state).sharedPresentation

export { getSharedPresentation, getFetchRequest, getCopyRequest }
